/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR) */
import { CAPTURE_PRESENTATION_GLOBAL_KEY, parseCapturePresentation } from '../../../api/src/types/capture-presentation';

/** Only an in-memory, origin-bound bootstrap value. Never URL or browser storage. */
export function readCapturePresentation() {
  if (typeof window === 'undefined') return null;
  return parseCapturePresentation(
    (window as unknown as Record<string, unknown>)[CAPTURE_PRESENTATION_GLOBAL_KEY], window.location.origin,
  );
}
